﻿import React from "react";
import { observer } from "mobx-react";
import type { IUploadStore } from "../../../UploadStore";
import { injectFromAppUpload } from "../../../inject";
import { FileUploadComponent } from "../../file/FileUploadComponent";

interface INotUploadableFilesComponent {
    uploadStore?: IUploadStore;
}

@injectFromAppUpload<INotUploadableFilesComponent>(stores => ({
    uploadStore: stores.uploadStore,
}))
@observer
export class NotUploadableFilesComponent extends React.Component<INotUploadableFilesComponent> {
    render() {
        const { uploadStore } = this.props;
        const { filesNotUploadable } = uploadStore!;

        if (filesNotUploadable.length === 0) {
            return null;
        }

        return (
            <div id={"not-uploadable-files-component"}>
                {filesNotUploadable.map(f => (
                    <FileUploadComponent key={f.fileGuid} file={f} />
                ))}
            </div>
        );
    }
}
